export function accordion() {
    let winWidth;
    let customAccordion;
    let loadButton;
    let smallAccordion;
    if ($(".cascade-blocks-section.section-with-accordion").length) {
        customAccordion = $(".cascade-blocks-section.section-with-accordion");
        customAccordion.find(".accordion .item:first-child").addClass("active").find(".hidden-info").slideDown();
    }

    $(window).on("load resize", function () {
        winWidth = window.innerWidth;
    });

    $(".accordion").on("click", "h4", function () {
        const parent = $(this).parent(".item");

        if (parent.hasClass("active")) {
            if (!customAccordion) {
                parent.removeClass("active").find(".hidden-info").slideUp();
            }
        } else {
            $(".accordion-wrap").find(".item").removeClass("active").find(".hidden-info").slideUp(350);
            parent.addClass("active").find(".hidden-info").slideDown();
        }
    });
    if ($(".accordion-load-button").length) {

        loadButton = $(".accordion-load-button");
        smallAccordion = loadButton.prev(".accordion");
        smallAccordion.find(".item:first-child h4").trigger("click");
        if (smallAccordion.find(".item").length > 5) {
            smallAccordion.find(".item").hide().slice(0, 5).show();
        } else {
            loadButton.hide();
        }
        loadButton.on("click", ".button", function () {
            let $this = $(this);
            if ($this.hasClass("active")) {
                $this.removeClass("active").text("Show More");
                $this.parent().prev().find(".item").slice(5, 20).slideUp(500);
            } else {
                $this.addClass("active").text("Show Less");
                $this.parent().prev().find(".item").slice(5, 20).slideDown(500);
            }

        });

    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js